export namespace Legal {
	export const PATH = 'legal';
	export const DATA_PATH = 'data';
	export const TERMS_AND_CONDITIONS_PATH = 'termsAndConditions';
	export const PRIVACY_POLICY_PATH = 'privacyPolicies';
	export const COOKIE_ADVICE_PATH = 'cookieNotices';
	export const REFUND_AND_DELIVERY_POLICY = 'refundDeliveryPolicy';
}
